import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext/AuthContext';
import PortalSpaceChrome, { PortalBrandLockup } from './PortalSpaceChrome';
import CustomerTabBar from './CustomerTabBar';
import './customerShell.css';

/* Mobile-first customer shell (mirrors WorkShell). Wraps /portal/customer/*
   under the existing RoleBasedRoute(['customer']) in PortalSpaceChrome — so the
   customer pages inherit the navy .portal-shell chrome, the Comfort data-theme
   system, the PWA titlebar-colour sync, and the logout menu for free — and adds
   the bottom tab bar.

   Logo → /portal/customer (the customer's home). The nested customer routes
   render into <Outlet/>.

   Pre-link state: a signed-in parent whose account isn't bound to a family yet
   has nothing to navigate, so the tab bar is suppressed and the Home body shows
   the "link your family" prompt (chrome only, matching the design's edge frame).
   The tab bar appears the moment familyId is set. */
function CustomerShell() {
	const { userProfile } = useAuth();
	const linked = !!userProfile?.familyId;

	return (
		<PortalSpaceChrome leading={<PortalBrandLockup to='/portal/customer' />}>
			<div className={`cust-shell${linked ? ' has-tabbar' : ''}`}>
				<Outlet />
			</div>
			{linked && <CustomerTabBar />}
		</PortalSpaceChrome>
	);
}

export default CustomerShell;
